var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { PureComponent } from "react";
import { FormattedMessage } from "@irati/utils/lang";
import StepLink from "./StepLink";
import { SectionTitle, SectionContent } from "./styled";
import stepDetails from "../../constants/stepConfig";
var NavSection = /** @class */ (function (_super) {
    __extends(NavSection, _super);
    function NavSection() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NavSection.prototype.render = function () {
        var _a = this.props, title = _a.title, steps = _a.steps, startingStepCount = _a.startingStepCount;
        if (steps.length === 0)
            return null;
        // div used instead of fragment to allow flexbox: space-evenly
        return (React.createElement("div", null,
            React.createElement(SectionTitle, { bold: true },
                React.createElement(FormattedMessage, { id: title })),
            React.createElement(SectionContent, null, steps.map(function (step, index) {
                return (React.createElement(StepLink, __assign({ state: step.state, key: step.stepId + "Step", stepNumber: startingStepCount + index }, stepDetails[step.stepId])));
            }))));
    };
    return NavSection;
}(PureComponent));
export default NavSection;
